import { MergeFieldQueryDto } from '@lmt/shared-types';

export enum DocumentViewerMode {
  Designer,
  Viewer,
}

export function isQueryIdentifiersEqual(
  query1?: MergeFieldQueryDto | null,
  query2?: MergeFieldQueryDto | null,
) {
  if (!query1 || !query2) return false;
  return (
    query1.queryType === query2.queryType &&
    query1.dataBlockTypeId === query2.dataBlockTypeId
  );
}
